import { createSlice } from '@reduxjs/toolkit';
import { submitClinicalDocs } from './thunks';
import { SliceStatus } from 'type-declarations';

export interface CaseState {
	caseSubmitted: boolean; //true when submitting updates to case
	status: SliceStatus;
}

const initialState: CaseState = {
	caseSubmitted: false,
	status: SliceStatus.IDLE,
};

export const caseSlice = createSlice({
	name: 'caseThunk',
	initialState,
	reducers: {
		resetCaseSlice: (state) => {
			Object.assign(state, initialState);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(submitClinicalDocs.pending, (state) => {
			state.status = SliceStatus.REFRESHING;
		}),
			builder.addCase(submitClinicalDocs.fulfilled, (state) => {
				state.status = SliceStatus.SUCCEEDED;
			});
		builder.addCase(submitClinicalDocs.rejected, (state) => {
			state.status = SliceStatus.REJECTED;
		});
	},
});

export const caseReducer = caseSlice.reducer;
export const caseActions = caseSlice.actions;
export const { resetCaseSlice } = caseActions;
